import { useEffect, useCallback } from "react";
import { useAuth } from "../auth/AuthContext";

export function usePermissions() {
  const { user, refreshUser } = useAuth();

  useEffect(() => {
    const handleUpdate = () => {
      refreshUser();
    };
    window.addEventListener("permissions-updated", handleUpdate);
    return () => window.removeEventListener("permissions-updated", handleUpdate);
  }, [refreshUser]);

  const canAccess = useCallback(
    (featureId: string): boolean => {
      if (!user) return false;
      const role = (user.role || "").toLowerCase();
      if (role === "super_admin") return true;

      if (user.permissions && typeof user.permissions[featureId] === "boolean") {
        return user.permissions[featureId];
      }

      // Default safety fallbacks while loading or if permissions undefined
      if (featureId === "dashboard") return true;
      if (role === "admin") {
        return true;
      }
      if (role === "analyst") {
        return ["dashboard", "intelligence_feed", "timeline", "customer_check", "domain_monitor", "alert_config", "takedowns", "review", "subscription", "reports_export", "api_access"].includes(featureId);
      }
      if (role === "client") {
        return ["dashboard", "intelligence_feed", "timeline", "customer_check", "alert_config", "takedowns", "subscription", "reports_export"].includes(featureId);
      }

      return false;
    },
    [user]
  );

  const showLockedTabs = user?.show_locked_tabs ?? true;

  return {
    canAccess,
    showLockedTabs,
    permissions: user?.permissions || {},
    role: user?.role || "client",
    refreshPermissions: refreshUser,
  };
}
